<ng-container *ngIf="kkm && kkm.network">
  <div class="ui-kit-block-title" data-qa="block-title">
    {{ 'kkm.settings.network' | translate }}
  </div>
  <div class="ui-kit-layout-columns-2">
    <span data-qa="tariff-type-title">{{ 'kkm.settings.network.type' | translate }}</span>
    <span data-qa="tariff-type" *ngIf="kkm.network.name as name">{{ name | translate }}</span>
  </div>

  <div *ngIf="kkm.network.id" class="ui-kit-layout-columns-2 network-number">
    <span>{{ 'kkm.settings.network.number' | translate }}</span>
    <tax-input
      class="network-number-input"
      taxNumbersOnly
      [(ngModel)]="simKkmId"
      (ngModelChange)="simKkmIdChange.emit($event)"
    ></tax-input>
  </div>

  <div class="ui-kit-layout-columns-2">
    <span data-qa="tariff-title">{{ 'kkm.settings.network.tariff' | translate }}</span>
    <span data-qa="tariff">{{ kkm.network.tariff }}</span>
  </div>

  <!--
  kkm.billingStatus === 0 - Тариф подключен;
  kkm.billingStatus === 1 - Тариф активен;
  kkm.billingStatus === 2 - Тариф приостановлен;
  kkm.billingStatus === 3 - Тариф отключен;
  kkm.billingStatus === 4 - Отключена за неуплату;
  ++-->
  <div
    *ngIf="billingStatusModel"
    [class]="billingStatusModel.className"
    [attr.data-qa]="'tariff-' + billingStatusModel.name"
  >
    {{ billingStatusModel.title | translate }}
    {{ kkm.billingStatusChangedAt | dateTime }}
  </div>

  <div *ngIf="kkm.tariffId && kkm.availableOperations.changeTariff">
    <button
      class="ui-kit-button_link"
      data-qa-link="kkm-tariffs"
      (click)="goToSelectSubscriptionPage(kkm.id)"
    >
      {{ 'kkm.status.change.tariff' | translate }}
    </button>
  </div>
</ng-container>
